// extracted by mini-css-extract-plugin
export var dataCell = "_ov-2";
export var dataRow = "_ov-0";
export var headerRow = "_ov-1";